export const CORNELL_CHOICES = [
  { value: "0", name: "Absent" },
  { value: 1, name: "Mild to intermittent" },
  { value: 2, name: "Severe" },
];

export const cornellDepressionLevels = [
  {
    label: "Unlikely Depression",
    scoreRange: "0-5",
    description:
      "Symptoms of depression are considered unlikely based on this score.",
    color: "success",
  },
  {
    label: "Possible Depression",
    scoreRange: "6-11",
    description:
      "Suggests possible or probable minor depression. Further monitoring is recommended.",
    color: "warning",
  },
  {
    label: "Probable Major Depression",
    scoreRange: "12-38",
    description:
      "Highly indicative of a major depressive episode. Requires clinical assessment and intervention.",
    color: "error",
  },
];

export const initialCornelFormData = {
  care_plan: "",
  anxiety: "",
  sadness: "",
  lack_of_reaction: "",
  irritability: "",
  agitation: "",
  retardation: "",
  multiple_physical_complaints: "",
  loss_of_interest: "",
  appetite_loss: "",
  weight_loss: "",
  lack_of_energy: "",
  diurnal_variation_of_mood: "",
  difficulty_falling_asleep: "",
  multiple_awakenings: "",
  early_morning_awakening: "",
  suicidal_feelings: "",
  poor_self_esteem: "",
  pessimism: "",
  mood_congruent_delusions: "",
  comments: "",
};

export const fields = [
  { name: "anxiety", label: "Anxiety, anxious expression, rumination" },
  { name: "sadness", label: "Sadness, sad expression, tearfulness" },
  { name: "lack_of_reaction", label: "Lack of reaction to pleasant events" },
  { name: "irritability", label: "Irritability, annoyed, short tempered" },
  { name: "agitation", label: "Agitation, restlessness, hand wringing" },
  {
    name: "retardation",
    label: "Retardation, slow movements, speech, reactions",
  },
  {
    name: "multiple_physical_complaints",
    label: "Multiple physical complaints",
  },
  { name: "loss_of_interest", label: "Loss of interest in usual activities" },
  { name: "appetite_loss", label: "Appetite loss, eating less" },
  { name: "weight_loss", label: "Weight loss" },
  { name: "lack_of_energy", label: "Lack of energy, fatigues easily" },
  { name: "diurnal_variation_of_mood", label: "Diurnal variation of mood" },
  { name: "difficulty_falling_asleep", label: "Difficulty falling asleep" },
  { name: "multiple_awakenings", label: "Multiple awakenings during sleep" },
  { name: "early_morning_awakening", label: "Early morning awakening" },
  {
    name: "suicidal_feelings",
    label: "Suicidal, feels life is not worth living",
  },
  { name: "poor_self_esteem", label: "Poor self-esteem, self-blame" },
  { name: "pessimism", label: "Pessimism, anticipation of the worst" },
  { name: "mood_congruent_delusions", label: "Mood congruent delusions" },
];
